// extracted by mini-css-extract-plugin
export var actions = "_fx-d";
export var benefitCard = "_fx-a";
export var benefitIcon = "_fx-b";
export var benefitLabel = "_fx-c";
export var benefits = "_fx-9";
export var bodyText = "_fx-8";
export var closeButton = "_fx-2";
export var content = "_fx-3";
export var eyebrow = "_fx-4";
export var heading = "_fx-5";
export var image = "_fx-f";
export var imagePanel = "_fx-e";
export var modal = "_fx-0";
export var shell = "_fx-1";
export var title = "_fx-6";
export var titleOffer = "_fx-7";